import { useEffect, useRef } from 'react';

import { usePaymentContext } from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

// Unless the practice requires invoice review, a payment pushed from the portal arms the card
// reader on its own, so the patient only ever presents a card — no "Pay" tap first. Runs inside
// the payment context because the card-present terminal decides whether the reader flow exists.
const KioskAutoStart = ({ enabled, onStart }) => {
  const { isKiosk, terminalData } = usePaymentContext();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (!enabled || hasStartedRef.current) return;
    if (!isKiosk || !terminalData?.cardPresentTerminal) return;

    hasStartedRef.current = true;
    onStart();
  }, [enabled, isKiosk, terminalData?.cardPresentTerminal, onStart]);

  return null;
};

export default KioskAutoStart;
